import { createMouseInput, type SharedEventLoop } from '@databases/selections';

import { type InputCapture } from '@canvas/input';

import { SelectionFeatureKeys, type SelectionInputFeature } from '../../features/types';

export interface MouseInputFeatureDeps {
  inputCapture: InputCapture;
  sharedLoop: SharedEventLoop;
}

export function createMouseInputFeature(
  deps: MouseInputFeatureDeps
): SelectionInputFeature {
  return {
    key: SelectionFeatureKeys.MOUSE_INPUT,
    type: 'input',
    // Always active — mouse input is fundamental to the selections machine.
    factory: (machine) => createMouseInput(machine, deps.inputCapture, deps.sharedLoop),
  };
}
